<p-confirmDialog key="appitem" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid 2 Col-->
<div class="Grid2Col">
	<!--Application items-->
	<div class="Submenu">
		<h5>Application Items:</h5>

		<p-treeTable
			[value]="TreeItems"
			[loading]="loading"
			[columns]="cols"
			selectionMode="single"
			[(selection)]="SelectedAppItem"
			dataKey="ApplicationItemName"
			(onNodeSelect)="nodeSelect($event)"
			(onNodeUnselect)="nodeUnselect($event)"
			[scrollable]="true"
			scrollHeight="flex"
		>
			<ng-template pTemplate="header">
				<tr>
					<th>Name</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
				<tr [ttSelectableRow]="rowNode">
					<td>
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						{{ rowData.ApplicationItemName }}
					</td>
				</tr>
			</ng-template>
		</p-treeTable>
	</div>

	<!--Modules Access Rights-->
	<div class="Submenu">
		<h5>Modules Access Rights:</h5>

		<!--Checkbox grid-->
		<div class="SubGrid2Col">
			<input
				(ngModelChange)="onFullRightsChange($event)"
				[(ngModel)]="CurrentFullRights"
				[disabled]="DisableCheck()"
				id="FullRights"
				class="form-control CheckBoxStyle"
				type="checkbox"
			/>
			<label for="FullRights">Full Rights</label>

			<!-- <input [disabled]="DisableControls == true" (ngModelChange)="onAccessReadChange($event)" [(ngModel)]="CurrentAccessRead" [disabled]="DisableCheck()" id="Access" class="form-control CheckBoxStyle" type="checkbox">
            <label for="Access">Access</label>

            <input [disabled]="DisableControls == true" (ngModelChange)="onAccessInsertChange($event)" [(ngModel)]="CurrentAccessInsert" [disabled]="DisableCheck()" id="Insert" class="form-control CheckBoxStyle" type="checkbox">
            <label for="Insert">Insert</label>

            <input [disabled]="DisableControls == true" (ngModelChange)="onAccessUpdateChange($event)" [(ngModel)]="CurrentAccessUpdate" [disabled]="DisableCheck()" id="Update" class="form-control CheckBoxStyle" type="checkbox">
            <label for="Update">Update</label>

            <input [disabled]="DisableControls == true" (ngModelChange)="onAccessDeleteChange($event)" [(ngModel)]="CurrentAccessDelete" [disabled]="DisableCheck()" id="Delete" class="form-control CheckBoxStyle" type="checkbox">
            <label for="Delete">Delete</label> -->
		</div>
	</div>
</div>
